import Permission, { getEditorPermissions, getViewerPermissions, PERMISSIONS, PERMISSIONS_ATTENDANCES, PERMISSIONS_EMPLOYEES, PERMISSIONS_IQAMA, PERMISSIONS_MEDICAL_PAPER, PERMISSIONS_OTHER_FILES, PERMISSIONS_PASSPORT, PERMISSIONS_SALARY_DEDUCTIONS, PERMISSIONS_TASHERA, PERMISSIONS_UMRAH, PERMISSIONS_UNIFORM, PERMISSIONS_VACATIONS } from "./Permission";

const ROLES_POWER_ACCESS_CONST = [
  'super',
  'admin',
  'editor',
  'viewer',
] as const;

const ROLES_CONST = [
  'editor.employees',
  'viewer.employees',
  'editor.attendances',
  'viewer.attendances',

  'editor.vacation',
  'viewer.vacation',
  'editor.iqama',
  'viewer.iqama',
  'editor.tashera',
  'viewer.tashera',
  'editor.otherFiles',
  'viewer.otherFiles',

  'editor.passport',
  'viewer.passport',
  'editor.uniform',
  'viewer.uniform',
  'editor.medical',
  'viewer.medical',
  'editor.umrah',
  'viewer.umrah',

  'editor.salaryDeduction',
  'viewer.salaryDeduction'
] as const;

const ROLES_GROUP_CONST = [
  'EMPLOYEES',
  'ATTENDANCE',
  'VACATION',
  'IQAMA',
  'TASHERA',
  'OTHER_FILES',
  'PASSPORT',
  'UNIFORM',
  'MEDICAL',
  'UMRAH',
  'SERVICES',
  'DASHBOARD',
  'SALARY_DEDUCTION'
] as const;

export const ROLES_POWER_ACCESS = [...ROLES_POWER_ACCESS_CONST]
export const ROLES = [...ROLES_CONST];

type Role = typeof ROLES_POWER_ACCESS_CONST[number] | typeof ROLES_CONST[number];

export type RoleGroup = typeof ROLES_GROUP_CONST[number];
export const ROLES_GROUP: {[key in RoleGroup]: Role[]} = {
  EMPLOYEES: [
    'editor.employees',
    'viewer.employees',
  ],
  ATTENDANCE: [
    'editor.attendances',
    'viewer.attendances',
  ],
  VACATION: [
    'editor.vacation',
    'viewer.vacation',
  ],
  IQAMA: [
    'editor.iqama',
    'viewer.iqama',
  ],
  TASHERA: [
    'editor.tashera',
    'viewer.tashera',
  ],
  OTHER_FILES: [
    'editor.otherFiles',
    'viewer.otherFiles',
  ],
  PASSPORT: [
    'editor.passport',
    'viewer.passport',
  ],
  UNIFORM: [
    'editor.uniform',
    'viewer.uniform',
  ],
  MEDICAL: [
    'editor.medical',
    'viewer.medical',
  ],
  UMRAH: [
    'editor.umrah',
    'viewer.umrah',
  ],

  // GROUP
  SERVICES: [
    'editor.vacation',
    'viewer.vacation',
    'editor.iqama',
    'viewer.iqama',
    'editor.tashera',
    'viewer.tashera',
    'editor.otherFiles',
    'viewer.otherFiles',
  ],
  DASHBOARD: [
    'editor.passport',
    'viewer.passport',
    'editor.uniform',
    'viewer.uniform',
    'editor.medical',
    'viewer.medical',
    'editor.umrah',
    'viewer.umrah',
  ],

  SALARY_DEDUCTION: [
    'viewer.salaryDeduction',
    'editor.salaryDeduction'
  ]
};

export const ROLES_PERMISSIONS_MAPPING: {[key in Role]: Permission[]} = {
  'super': PERMISSIONS,
  'admin': PERMISSIONS,
  'editor': getEditorPermissions(PERMISSIONS),
  'viewer': getViewerPermissions(PERMISSIONS),

  'editor.employees': getEditorPermissions(PERMISSIONS_EMPLOYEES),
  'viewer.employees': getViewerPermissions(PERMISSIONS_EMPLOYEES),
  'editor.attendances': getEditorPermissions(PERMISSIONS_ATTENDANCES),
  'viewer.attendances': getViewerPermissions(PERMISSIONS_ATTENDANCES),

  'editor.vacation': getEditorPermissions(PERMISSIONS_VACATIONS),
  'viewer.vacation': getViewerPermissions(PERMISSIONS_VACATIONS),
  'editor.iqama': getEditorPermissions(PERMISSIONS_IQAMA),
  'viewer.iqama': getViewerPermissions(PERMISSIONS_IQAMA),
  'editor.tashera': getEditorPermissions(PERMISSIONS_TASHERA),
  'viewer.tashera': getViewerPermissions(PERMISSIONS_TASHERA),
  'editor.otherFiles': getEditorPermissions(PERMISSIONS_OTHER_FILES),
  'viewer.otherFiles': getViewerPermissions(PERMISSIONS_OTHER_FILES),

  'editor.passport': getEditorPermissions(PERMISSIONS_PASSPORT),
  'viewer.passport': getViewerPermissions(PERMISSIONS_PASSPORT),
  'editor.uniform': getEditorPermissions(PERMISSIONS_UNIFORM),
  'viewer.uniform': getViewerPermissions(PERMISSIONS_UNIFORM),
  'editor.medical': getEditorPermissions(PERMISSIONS_MEDICAL_PAPER),
  'viewer.medical': getViewerPermissions(PERMISSIONS_MEDICAL_PAPER),
  'editor.umrah': getEditorPermissions(PERMISSIONS_UMRAH),
  'viewer.umrah': getViewerPermissions(PERMISSIONS_UMRAH),

  'editor.salaryDeduction': getEditorPermissions(PERMISSIONS_SALARY_DEDUCTIONS),
  'viewer.salaryDeduction': getViewerPermissions(PERMISSIONS_SALARY_DEDUCTIONS),
};

type RoleDescription = {
  [key in Role]: {
    name: string;
    description: string;
  };
};
export const ROLES_DESCRIPTIONS: RoleDescription = {
  'super': {
    name: 'Super Admin',
    description: 'Power access. Can perform all the functions.',
  },
  'admin': {
    name: 'Administrator',
    description: `Power access. Can perform all the functions except removing 'super' and 'admin' roles.`,
  },
  'editor': {
    name: 'Editor',
    description: ''
  },
  'viewer': {
    name: 'Viewer',
    description: ''
  },

  'editor.employees': {
    name: 'Editor - Employees',
    description: ''
  },
  'viewer.employees': {
    name: 'Viewer - Employees',
    description: ''
  },
  'editor.attendances': {
    name: 'Editor - Attendances',
    description: ''
  },
  'viewer.attendances': {
    name: 'Viewer - Attendances',
    description: ''
  },

  'editor.vacation': {
    name: 'Editor - Vacations',
    description: ''
  },
  'viewer.vacation': {
    name: 'Viewer - Vacations',
    description: ''
  },
  'editor.iqama': {
    name: 'Editor - Iqama Receipts',
    description: ''
  },
  'viewer.iqama': {
    name: 'Viewer - Iqama Receipts',
    description: ''
  },
  'editor.tashera': {
    name: 'Editor - Tashera',
    description: ''
  },
  'viewer.tashera': {
    name: 'Viewer - Tashera',
    description: ''
  },
  'editor.otherFiles': {
    name: 'Editor - Other Files',
    description: ''
  },
  'viewer.otherFiles': {
    name: 'Viewer - Other Files',
    description: ''
  },

  'editor.passport': {
    name: 'Editor - Passport Requests',
    description: ''
  },
  'viewer.passport': {
    name: 'Viewer - Passport Requests',
    description: ''
  },
  'editor.uniform': {
    name: 'Editor - Uniform Requests',
    description: ''
  },
  'viewer.uniform': {
    name: 'Viewer - Uniform Requests',
    description: ''
  },
  'editor.medical': {
    name: 'Editor - Medical Paper Requests',
    description: ''
  },
  'viewer.medical': {
    name: 'Viewer - Medical Paper Requests',
    description: ''
  },
  'editor.umrah': {
    name: 'Editor - Umrah Paper Requests',
    description: ''
  },
  'viewer.umrah': {
    name: 'Viewer - Umrah Paper Requests',
    description: ''
  },

  'editor.salaryDeduction': {
    name: 'Editor - Salary Deductions',
    description: 'Can create/update/delete employee salary deductions.'
  },
  'viewer.salaryDeduction': {
    name: 'Viewer - Salary Deductions',
    description: 'Can view employee\'s salary deduction.'
  },
}

export const hasRole = (roles: string[], role: Role) => {
  return roles.some(r => {
    if (ROLES_PERMISSIONS_MAPPING.hasOwnProperty(r)) {
      return (r as Role) === role;
    }
  });
}

export default Role;
